<template>
  <div class="statistics-network">
    <div class="header">
      <el-radio-group :value="shortcuts" @input="onShortcutsChange">
        <el-radio-button :label="tWeek"></el-radio-button>
        <el-radio-button :label="tMonth"></el-radio-button>
      </el-radio-group>
      <el-date-picker
        :clearable="false"
        v-model="range"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyy-MM-dd"
        range-separator="至"
        :picker-options="{
          disabledDate,
          firstDayOfWeek: 1,
        }"
      />
      <el-button
        class="download-btn"
        icon="el-icon-download"
        type="text"
        @click="download"
      />
    </div>
    <div class="content mt20">
      <div>
        <span>服务器统计流量: {{serverTraffic}} G</span>
        <span class="ml20">盒子总计流量: {{boxTraffic}} G</span>
      </div>
      <el-table :data="tablePageData" class="table" v-loading="loading">
        <el-table-column prop="cname" label="客户名称" min-width="140"/>
        <el-table-column prop="traffic" label="盒子统计流量(G)" min-width="140"/>
        <el-table-column prop="cameraCount" label="绑定的摄像头数" min-width="140"/>
      </el-table>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="tableData.length"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as xlsx from 'xlsx-js-style'
import { solution } from '../../api/product'
// 将moment的一周dayOfWeek从周日改为周一
moment.locale('zh-cn', {
  week: {
    dow: 1,
  },
})
const tWeek = '本周'
const tMonth = '本月'
export default {
  data() {
    return {
      range: [],
      tWeek,
      tMonth,
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      loading: false,
      serverTraffic: 0,
      boxTraffic: 0,
    }
  },
  computed: {
    tablePageData() {
      const start = (this.currentPage - 1) * this.pageSize
      const end = this.currentPage * this.pageSize
      return this.tableData.slice(start, end)
    },
    shortcuts() {
      if (this.isThisWeek(this.range)) {
        return tWeek
      }
      if (this.isThisMonth(this.range)) {
        return tMonth
      }
      return ''
    }
  },
  watch: {
    range() {
      this.getAllData()
    },
  },
  mounted() {
    this.range = this.getThisWeek()
    this.getAllData()
  },
  methods: {
    onShortcutsChange(val) {
      if (val === tWeek) {
        this.range = this.getThisWeek()
      } else if (val === tMonth) {
        this.range = this.getThisMonth()
      }
    },
    getAllData() {
      this.getData()
      this.getCount()
    },
    handleSizeChange(val) {
      this.pageSize = val
    },
    handleCurrentChange(val) {
      this.currentPage = val
    },
    async getData() {
      try {
        this.loading = true
        const res = await solution.getNetworkTrafficList({
          startDate: this.range[0],
          endDate: this.range[1],
        })
        if (res.status === 0) {
          this.tableData = res.data
          this.currentPage = 1
        }
      } finally {
        this.loading = false
      }
    },
    async getCount() {
      const res = await solution.getNetworkTrafficCount({
        startDate: this.range[0],
        endDate: this.range[1],
      })
      if (res.status === 0) {
        this.serverTraffic = res.data?.traffic || 0
        this.boxTraffic = res.data?.customerTraffic || 0
      }
    },
    getThisWeek() {
      const now = moment()
      return [
        now.clone().startOf('week'),
        now
      ].map(date => date.format('YYYY-MM-DD'))
    },
    getThisMonth() {
      const now = moment()
      return [
        now.clone().startOf('month'),
        now
      ].map(date => date.format('YYYY-MM-DD'))
    },
    isThisWeek(range) {
      const thisWeek = this.getThisWeek()
      return range[0] === thisWeek[0] && range[1] === thisWeek[1]
    },
    isThisMonth(range) {
      const thisMonth = this.getThisMonth()
      return range[0] === thisMonth[0] && range[1] === thisMonth[1]
    },
    disabledDate(time) {
      const now = new Date()
      const year = now.getFullYear()
      const month = now.getMonth()
      const day = now.getDate()
      const today = new Date(year, month, day)
      return time > today
    },
    download() {
      const headerStyle = {
        fill: {
          fgColor: { rgb: '28bc4a' },
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
        }
      }
      // 下载表格
      try {
        const fileName = this.range[0] === this.range[1]
          ? `流量统计_${this.range[0]}.xlsx`
          : `流量统计_${this.range[0]}_${this.range[1]}.xlsx`
        const header = ['客户名称', '盒子统计流量(G)', '绑定的摄像头数']
        const rows = this.tableData.map(item => [item.cname, item.traffic, item.cameraCount])
        const worksheet = xlsx.utils.aoa_to_sheet([header, ...rows])
        worksheet['!cols'] = [{ wpx: 200 }, { wpx: 120 }, { wpx: 120 }]
        worksheet['!rows'] = [{hpx: 30}, ...rows.map(() => ({ hpx: 25 }))]
        header.forEach((_, idx) => {
          const cellAddress = xlsx.utils.encode_cell({ r: 0, c: idx })
          worksheet[cellAddress].s = headerStyle
        })
        rows.forEach((row, rIdx) => {
          row.forEach((item, cIdx) => {
            const cellAddress = xlsx.utils.encode_cell({ r: rIdx + 1, c: cIdx })
            worksheet[cellAddress].s = {
              alignment: {
                horizontal: cIdx !== 0 ? 'right' : 'center',
                vertical: 'center'
              }
            }
          })
        })
        const workbook = xlsx.utils.book_new()
        xlsx.utils.book_append_sheet(workbook, worksheet, 'Sheet1')
        const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array', bookSST: true, cellStyles: true })
        const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        const link = document.createElement('a')
        link.download = fileName
        link.href = URL.createObjectURL(blob)
        link.click()
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.statistics-network {
  background: #fff;
  padding: 20px;
  min-height: calc(100vh - 135px);
  .header {
    display: flex;
    .download-btn {
      margin-left: auto;
      margin-right: 20px;
      font-size: 20px;
    }
  }
  .content {
    font-size: 14px;
    .table {
      width: 100%;
      /deep/ .cell {
        font-size: 14px;
      }
    }
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
</style>
